<template>
  <div>
    <data-table :service="SubscriptionService"
                service-method="filterSubscriptions"
                :service-params="serviceParams"
                operations="refresh"
                :entity="entity"
                :columns="columns"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                rowNavigationKey="id"
                @on-row-click="onRowClick"
                ref="table">
      <template v-slot:extra-buttons="{row}">
        <tooltip-icon-button icon="far fa-edit"
                             :content="$t('generic.edit')"
                             @click.stop="onRowClick(row)">
        </tooltip-icon-button>
      </template>
      <template v-slot:active="{row}">
        <status-badge :status="row.active ? $t('generic.active') : $t('generic.inactive')"></status-badge>
      </template>
      <template v-slot:client.name="{row}">
        <router-link :to="`/contacts/clients/${getByKey(row, 'client_uuid')}`">
          {{getByKey(row, 'client.name')}}
        </router-link>
      </template>
      <template v-slot:product_job_board.name="{row}">
        <router-link :to="`/settings/products/${getByKey(row, 'product_job_board.product_id')}`">
          {{getByKey(row, 'product_job_board.name')}}
        </router-link>
      </template>
      <template v-slot:product_job_board.job_board.name="{row}">
        <router-link :to="`/content/job-board/${getByKey(row, 'product_job_board.job_board_id')}`">
          {{getByKey(row, 'product_job_board.job_board.name')}}
        </router-link>
      </template>
      <template v-slot:valid_till="{row}">
        {{row.valid_till || $t('subscriptions.noEndTime')}}
      </template>
      <template v-slot:next_payment_cycle="{row}">
        {{$formatDate(row.next_payment_cycle, 'MMM Do yyyy')}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import getByKey from 'lodash/get'
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'
  import SubscriptionService from 'src/services/SubscriptionService'
  import entities from 'src/config/entities'
  import { getRouteName } from 'src/config/routeTypes'

  export default {
    name: 'subscriptions-list',
    components: {
      TooltipIconButton
    },
    props: {
      clientId: {
        type: String,
      }
    },
    data () {
      return {
        SubscriptionService,
        entity: entities.SUBSCRIPTION,
      }
    },
    computed: {
      columns () {
        let baseColumns = [
          {
            prop: 'title',
            label: this.$t('generic.title'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'active',
            label: this.$t('generic.active'),
            minWidth: '100px'
          },
          {
            prop: 'amount',
            label: this.$t('generic.amount'),
            minWidth: '80px',
            sortable: true
          },
          {
            prop: 'product_job_board.name',
            label: this.$t('generic.product'),
            minWidth: '150px',
          },
          {
            prop: 'product_job_board.job_board.name',
            label: this.$t('generic.jobBoard'),
            minWidth: '150px',
          },
          {
            prop: 'valid_till',
            label: this.$t('generic.validTill'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'next_payment_cycle',
            label: this.$t('generic.nextPayment'),
            minWidth: '150px',
            sortable: true
          }
        ]
        if (!this.clientId) {
          baseColumns.push({
            prop: 'client.name',
            label: this.$t('generic.client'),
            minWidth: '200px',
          })
        }
        return baseColumns
      },
      serviceParams () {
        if (this.clientId) {
          return {
            client_id: this.$route.params.id
          }
        }
        return {}
      }
    },
    methods: {
      getByKey,
      onRowClick(row) {
        this.$router.push({
          name: getRouteName('subscription-details', entities.SUBSCRIPTION),
          params: {
            id: row.client_uuid,
            subscriptionId: row.id
          }
        })
      }
    }
  }
</script>
<style>
</style>
